module.exports = __webpack_public_path__ + "img/logo-comgas.4c7c4000.svg";